import { Box, TextField, styled } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: '16px',
  display: 'grid',
  gridTemplateColumns: 'repeat(5, 1fr)',
  gap: '10px 16px',
  borderRadius: '16px',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.info.main,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.info.main,
    },
  },
}));
